import { Autocomplete, TextField } from '@mui/material';
import type { AutocompleteProps } from '@mui/material/Autocomplete';
import { AGGREGATION_OPERATORS } from '@vy/types';
import { values } from '@vy/utils';
import React from 'react';

type AggregationSelectProps = Omit<
  AutocompleteProps<string, false, false, false>,
  'options' | 'renderInput'
> & {
  inputRef?: React.Ref<HTMLInputElement>;
};

export const AggregationSelect: React.FC<AggregationSelectProps> = ({ inputRef, ...props }) => {
  return (
    <Autocomplete
      size="small"
      {...props}
      options={values(AGGREGATION_OPERATORS)}
      renderInput={(params) => (
        <TextField
          label="Aggregation"
          placeholder="Select aggregation"
          {...params}
          inputRef={inputRef}
          slotProps={{
            ...params.slotProps,

            htmlInput: {
              ...params.slotProps.htmlInput,
              autoComplete: 'new-password',
            },

            inputLabel: { shrink: true }
          }} />
      )}
    />
  );
};
